import { connect } from 'react-redux';
import { addEvent, editEvent, updateEventStay, removeEvent, requestProposals, } from '../modules/tour';
import { requestHotelSearch, requestHotelAdvanceSearch } from '../../hotels/modules/hotels';

import EventDetailModal from './EventDetailModal';

const mapDispatchToProps = {
  addEvent,
  editEvent,
  updateEventStay,
  removeEvent,
  requestHotelSearch,
  requestHotelAdvanceSearch,
  requestProposals,
};

const mapStateToProps = state => ({
  proposals: state.tours.selectedTour.proposals,
  tour: state.tours.selectedTour.tour,
  places: state.tours.places,
  tourId: state.tours.selectedTour.tour.id
});
const EventDetailModalContainer = connect(mapStateToProps, mapDispatchToProps)(EventDetailModal);
export default EventDetailModalContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/EventDetailModalContainer.js